"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.useDataGridContext = exports.DataGridContext = void 0;

var _react = require("react");

var DataGridContext = (0, _react.createContext)({});
exports.DataGridContext = DataGridContext;

var useDataGridContext = function useDataGridContext() {
  var context = (0, _react.useContext)(DataGridContext);

  if (!context) {
    throw new Error('No context found for useDataGridContext');
  }

  return context;
};

exports.useDataGridContext = useDataGridContext;
var _default = DataGridContext;
exports["default"] = _default;